<div class="right-panel h-100">
  <div class="actionBar">
    <input type="text"
           placeholder="Search by template name..."
           [(ngModel)]="searchTerm"
           (ngModelChange)="onSearchChange()"
           class="search" />

    <button type="button" class="actionBtn" (click)="refreshComponent()" placement="top auto" triggers="hover" ngbTooltip="Refresh">
      <span class="bi bi-arrow-clockwise"></span>
     
    </button>

  </div>
  <div class="logTable">
    <div [ngStyle]="{ 'flex-grow': dataAvailable ? '1' : '' }">
      <table class="table table-striped">
        <thead>
          <tr class="table-list-head">
            <th resizable>#</th>
            <th resizable>Template Name</th>
            <th resizable>Deployment</th>
            <th resizable>Application</th>
            <th resizable>Application Version</th>
            <th resizable>Created By</th>
            <th *ngIf="isMonitor == false" resizable>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr class="table-list-row" *ngFor="let jobTemplate of filteredTemplates | paginate: { itemsPerPage: 14, currentPage: p };
                        let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ jobTemplate.templateName }}</td>
            <td>{{ jobTemplate.deploymentId }}</td>
            <td>{{ jobTemplate.application }}</td>
            <td>{{ jobTemplate.applicationVersion }}</td>
            <td>{{ jobTemplate.userId }}</td>
            <td *ngIf="isMonitor == false">
              <button class="actionBtn"
                      style="border: 1px solid var(--s-primary-color)"
                      title="Rename Template"
                      (click)="updateJobTemplate(jobTemplate)">
                <span class="bi bi-pencil-square"></span> 
              </button>

              <button class="actionBtn"
                      style="border: 1px solid var(--s-primary-color)"
                      title="Delete Template"
                      (click)="deleteJobTemplate(jobTemplate.templateId)">
                <span class="bi bi-x-lg" style="color: red;"></span> 
              </button>

            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="errorMsg" *ngIf="!dataAvailable">No Action logs available.</p>
    <pagination-controls *ngIf="dataAvailable"
                         class="my-pagination"
                         (pageChange)="p = $event"></pagination-controls>
  </div>
  <ngx-spinner bdColor="rgba(0,0,0,0)"
               size="default"
               zIndex="1"
               color="var(--s-primary-color)"
               type="ball-spin"
               [fullScreen]="false"><p class="pleaseWait">Please wait ...</p></ngx-spinner>
</div>
